import { createContext, useState } from "react";

// Create multiple contexts that we can pull data from on every page
export const FilterContext = createContext();
FilterContext.displayName = "ResourceFilterContext";

export const FilterContextProvider = props => {
    const [isLoading, setLoading] = useState(false);
    const [resources, setResources] = useState(null);

    return (
        <FilterContext.Provider
            value={{ isLoading, setLoading, resources, setResources }}
        >
            {props.children}
        </FilterContext.Provider>
    );
};
